<header #navbar class="fixed w-full z-50 navbar  transition-colors duration-300" style=" background: #f3f5f9eb;">
    <div
        class="mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] flex justify-between items-center py-4">
        <div class="text-xl font-bold">
            <img src="../../../../assets/images/landing/logo.png" alt="CompanyName"
                class="h-8 w-auto max-w-full object-contain sm:h-8">
        </div>
        <nav class="flex items-center gap-6 justify-end">
            <!--/inicio -->
            <a *ngIf="!isLandingRoute" class="items-navbar-page relative text-gray-700 text-sm font-medium py-1">
                {{ 'words.start' | translate }}
                  <i class="fas fa-arrow-right"></i>
            </a>

            <!-- /catalog -->
            <a *ngIf="!isCatalogRoute" class="items-navbar-page relative text-gray-700 text-sm font-medium py-1">
                {{ 'words.catalogue' | translate }}
                <i class="fas fa-arrow-right"></i>
            </a>

            <button class="btn-page  text-white px-4 py-2 rounded-lg bg-primary   text-sm">Login</button>
        </nav>
    </div>
</header>